/*
 * GALPÓN — Click-to-open del mega-menú (patrón disclosure WAI-ARIA).
 * ---------------------------------------------------------------------------
 * Los items del navbar CON submenu son <button data-gd-nav-toggle> (ver
 * blocks/_header-menu.liquid), SIN los on:pointerenter/focus="/activate" de
 * Horizon → no se abren por hover. Premium tipo Oakâme/Aesop: el panel se abre
 * SOLO por click.
 *
 * CLAVE: NO toggleamos aria-expanded a mano — eso no muestra el panel (Horizon
 * abre vía su método activate(), que setea --submenu-height / --submenu-opacity /
 * pointer-tracking; el atributo solo no basta). Usamos la API PÚBLICA del custom
 * element <header-menu>: activate(event) / deactivate(event). Es su propio motor,
 * no un parche: el panel abre/cierra con TODA la lógica nativa (alturas, fade).
 *
 * Accesibilidad: el <button> da Enter/Space nativo (disparan click). Escape cierra.
 * Click-fuera cierra. aria-expanded lo gestiona el propio activate/deactivate.
 */
(function () {
  'use strict';

  const NAV = 'header-component';
  const TOGGLE = '[data-gd-nav-toggle]';

  /** El <header-menu> que contiene a un nodo (su motor de apertura). */
  const headerMenuFor = (node) => node.closest('header-menu');

  /** ¿Está abierto este toggle? (su item es el activeItem de Horizon) */
  const isOpen = (btn) => btn.getAttribute('aria-expanded') === 'true';

  // Horizon.activate/deactivate esperan event.target = el <li> contenedor (su
  // findMenuItem hace target.querySelector('[ref="menuitem"]') → necesita el <li>,
  // NO el <button> que ES el menuitem). Por eso pasamos el <li>.
  const liFor = (btn) => btn.closest('.menu-list__list-item');

  /** Cierra cualquier panel abierto del navbar usando la API de Horizon. */
  const closeAll = () => {
    const open = document.querySelectorAll(NAV + ' ' + TOGGLE + '[aria-expanded="true"]');
    for (const btn of open) {
      const hm = headerMenuFor(btn);
      if (hm && typeof hm.deactivate === 'function') {
        hm.deactivate({ target: liFor(btn), type: 'gd-close', relatedTarget: null });
      } else {
        btn.setAttribute('aria-expanded', 'false'); // fallback defensivo
      }
    }
  };

  /** Abre el panel de un toggle vía el activate() nativo de Horizon. */
  const open = (btn) => {
    const hm = headerMenuFor(btn);
    if (hm && typeof hm.activate === 'function') {
      hm.activate({ target: liFor(btn) });
    }
  };

  // Click en un toggle → toggle del panel (con la API nativa).
  document.addEventListener('click', (event) => {
    const btn = event.target.closest(TOGGLE);
    if (btn && btn.closest(NAV)) {
      event.preventDefault();
      if (isOpen(btn)) {
        closeAll();
      } else {
        closeAll(); // cerrar cualquier otro abierto primero
        open(btn);
      }
      return;
    }
    // Click fuera del navbar → cerrar.
    if (!event.target.closest(NAV)) closeAll();
  });

  // Escape → cerrar y devolver foco al toggle que estaba abierto.
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const active = document.querySelector(NAV + ' ' + TOGGLE + '[aria-expanded="true"]');
    closeAll();
    if (active && active.focus) active.focus();
  });

  // Navegar (click en link interno) y bfcache → asegurar todo cerrado.
  document.addEventListener('click', (event) => {
    const a = event.target.closest('a[href]');
    if (a && a.getAttribute('href') && a.getAttribute('href').charAt(0) !== '#') closeAll();
  });
  // SOLO en restauración real desde bfcache (persisted). En la CARGA INICIAL (persisted
  // false) pageshow dispara DESPUÉS de load (cientos de ms con assets lentos); si el usuario
  // ya clickeó y abrió el mega-menú, este closeAll lo CERRABA solo dejando el activeItem de
  // Horizon colgado → "abre y se cierra solo, botón muerto hasta clickear otro". ESE era el bug.
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) closeAll();
  });
})();
